import Dialog from "../../../components/Dialog";
import React, {useCallback, useEffect, useState} from "react";
import TextInputItem from "../../../components/TextInputItem";
import {
  convertAgent,
  selectApp, setAgent
} from "../appSlice";
import {useDispatch, useSelector} from "react-redux";
import {Spinner} from "../../../components/Spinner";
import {useNavigate} from "react-router";
import {getResults, selectResults} from "../../results/resultsSlice";
import {getHtiHostedImageURL, storeAgentLogin} from "../../Util";
import {Link, useLocation} from "react-router-dom";
import {
  buildPasswordRestrictions,
  getErrorMessage,
  getSinglePropertyId, handleAppleAuth, handleForgotPassword,
  handleGoogleAuth, handleMicrosoftAuth, handlePasswordAuth, handleResendEmail,
  isErrorAuthResponse,
  processAuthErrorRS
} from "../appUtil";
import {
  getAuth,
  validatePassword,
} from "firebase/auth";
import {useNebulaAuth} from "../../../hooks/useNebulaAuth";
import {DIRECT_AUTH, getApiUrl} from "../../../api/client";
import {firebaseAppNebulaOne} from "../../../App";
import useRestFetch, {FETCH} from "../../../hooks/useRestFetch";

const Error = ({message}) => {

  return (
      <div className={'bn-error-message'}>
        <p>{message}</p>
      </div>
  )
}

export default React.memo(({open, autoSearch, onOpenChange}) => {

  const navigate = useNavigate();
  const location = useLocation()

  const {
    criteria,
    hasResults,
    site, singleProperty} = useSelector(
      state => ({
        loginBusy: selectApp(state).loginBusy,
        errorType: selectApp(state).errorType,
        criteria: selectResults(state).criteria,
        hasResults: selectResults(state).hasResults,
        site: selectApp(state).site,
        singleProperty: selectApp(state).singleProperty,
      }));
  const customer = useSelector(state => selectApp(state).customer);

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('');
  const [forgetPassword, setForgetPassword] = useState(false);
  const [passwordRestrictions, setPasswordRestrictions] = useState([])
  const [register, setRegister] = useState(false)
  const [emailSent, setEmailSent] = useState(false);
  const [emailVerifySent, setEmailVerifySent] = useState(false)
  const [resendEmail, setResendEmail] = useState(false)
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(undefined);

  const {authSSO, busy: authSSOBusy} = useNebulaAuth();
  const {fetch: fetchContact, busy: contactFetchBusy} = useRestFetch();

  const auth = getAuth(firebaseAppNebulaOne);

  const dispatch = useDispatch();
  const getResults_ = useCallback((criteria) => dispatch(getResults(criteria)),
      [dispatch]);

  useEffect(() => {
    if (open) {
      setEmail('');
      setPassword('');
      setResendEmail(false)
      setEmailVerifySent(false)
      setError(undefined)
    }
  }, [open]);

  const signInSuccess = useCallback((email, idToken) => {

    if (customer) {
      authSSO(email, idToken, getApiUrl(customer, DIRECT_AUTH), 'cb').then(
          response => {

            // console.log('authSSO rs', response)

            if (!isErrorAuthResponse(response.data)) {
              // fetch contact on success
              const user = response.data;

              if (user.contactId) {

                fetchContact({
                      ID: user.contactId,
                    }, 'Contact', 'withoutPassword', FETCH,
                    customer, user.token).then(r => {
                  if (!r.error) {
                    onOpenChange(false);

                    const agent = convertAgent(r[0]);
                    storeAgentLogin(agent);
                    dispatch(setAgent({agent}))

                    if (location.pathname.indexOf("/confirmation/") === -1) { // only redict if not on confirmation page
                      navigate(
                          !singleProperty ? '/' : `/hotel/${getSinglePropertyId(
                              site)}`)

                      if (hasResults) {
                        getResults_(Object.assign({}, criteria,
                            {agentId: agent.agentId}));
                      }
                    } else {
                      window.location.reload();
                    }
                  }
                });

              } else {
                setError('Cannot authenticate user. Please contact support.');
              }

            } else {
              console.error('error', response.data)

              setError(processAuthErrorRS(response.data));
            }

          }).catch(error => {
        console.error('error', error)

        setError(getErrorMessage(error))
      })
    }

  }, [customer, authSSO]);

  const handleRegister = (register, auth, passwordRestrictions) => {
    setRegister(register)
    setEmail('')
    setPassword('')
    setError('')

    if (!passwordRestrictions || passwordRestrictions.length === 0) {
      validatePassword(auth, 'password').then(status => {

        const {passwordPolicy} = status;

        setPasswordRestrictions(buildPasswordRestrictions(passwordPolicy))
      });
    }
  }

  return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <>
          <div className={"bn-dialog-content"}>
            {!register && !forgetPassword &&
                <div className={"bn-agent-login-container"}>
                  <div className={'bn-agent-login-header-container'}>
                    <h4>Agent Login</h4>
                  </div>
                  <div className={'bn-inputs-group'}>
                    <TextInputItem className={"bn-group bn-input-item"}
                                   type={"text"}
                                   id={"email"}
                                   label={"E-mail"}
                                   placeholder={"E-mail"}
                                   mandatory={true}
                                   maxLength={50}
                                   value={email}
                                   onChange={(event) => setEmail(
                                       event.target.value)}
                    />
                    <TextInputItem className={"bn-group bn-input-item"}
                                   type={"password"}
                                   id={"password"}
                                   label={'Password'}
                                   placeholder={'Password'}
                                   mandatory={true}
                                   maxLength={50}
                                   value={password}
                                   onChange={(event) => setPassword(
                                       event.target.value)}
                    />
                  </div>

                  <div className={"bn-forgot-password-container"}>
                    <Link style={{cursor: "pointer"}}
                          onClick={() => {
                            setForgetPassword(true)
                            setEmailSent(false)
                            setEmail('')
                            setPassword('')
                            setError(undefined)
                          }}>Forgot password?</Link>
                  </div>

                  {error && <Error message={error}/>}

                  {emailVerifySent && <div className={'bn-agent-signup-verify-sent-container'}>
                    <p>Please check your email to verify your account.</p>
                  </div>}

                  <div className={"bn-dialog-button-container"}>
                    {(!resendEmail && !emailVerifySent) && <button className={'bn-booknow-button'}
                             disabled={!email || !password || busy}
                             onClick={() => handlePasswordAuth(auth, email,
                                 password,
                                 signInSuccess, setResendEmail, setBusy,
                                 setError)}
                    >Sign In</button>}

                    {resendEmail && <button className={'bn-booknow-button'}
                                            disabled={!email || !password || busy}
                                            onClick={() => handleResendEmail(auth,
                                                email,
                                                password,
                                                setResendEmail,
                                                setEmailVerifySent,
                                                setBusy, setError)}
                    >Resend E-mail</button>}
                  </div>

                  <div className={'bn-agent-login-diver-container'}>
                    <div className={'bn-agent-login-diver'}/>
                    OR
                    <div className={'bn-agent-login-diver'}/>
                  </div>

                    {authSSOBusy && <div className={'bn-agent-login-progress-container'}>
                    <Spinner size={'18px'}/>
                  </div>}

                    {!authSSOBusy && <div className={'bn-agent-login-alternate-logins-container'}>
                    Sign in with

                      <div className={'bn-agent-login-alternate-login-img-container'}>
                      {customer && <div
                          className={'bn-agent-login-alternate-login-img'}
                          onClick={() => handleGoogleAuth(auth, signInSuccess,
                              setBusy,
                              setError)}>
                        <img src={getHtiHostedImageURL(customer,
                            'icon-google.png')} alt={'Google account'}/>
                      </div>}

                      {customer && <div
                          className={'bn-agent-login-alternate-login-img'}
                          onClick={() => handleMicrosoftAuth(auth,
                              signInSuccess, setBusy,
                              setError)}>
                        <img src={getHtiHostedImageURL(customer,
                            'icon-microsoft.png')} alt={'Microsoft account'}/>
                      </div>}

                      {customer && <div
                          className={'bn-agent-login-alternate-login-img'}
                          onClick={() => handleAppleAuth(auth, signInSuccess,
                              setBusy,
                              setError)}>
                        <img src={getHtiHostedImageURL(customer,
                            'icon-apple.png')} alt={'Apple account'}/>
                      </div>}
                    </div>
                  </div>}

                </div>}

            {
                forgetPassword && <div className={'bn-agent-login-container'}>
                  <div className={'bn-agent-login-header-container'}>
                    <h4>Forgot Password</h4>
                    <div className={'bn-agent-login-signup-link-container'}>
                      Already know your password?
                      <Link style={{cursor: "pointer"}}
                            onClick={() => {
                              setForgetPassword(false)
                              setError(undefined)
                            }}>Login</Link>
                    </div>
                  </div>
                  <div className={'bn-agent-login-forgot-password-description'}>
                    Please enter the E-mail associated with your account.
                  </div>
                  <div className={'bn-inputs-group'}>
                    <TextInputItem className={"bn-group bn-input-item"}
                                   type={"text"}
                                   id={"email"}
                                   label={"E-mail"}
                                   placeholder={"E-mail"}
                                   mandatory={true}
                                   maxLength={50}
                                   value={email}
                                   onChange={(event) => setEmail(
                                       event.target.value)}
                    />
                  </div>

                  <div className={'bn-dialog-button-container'}>
                    {!emailSent && <button className={'bn-booknow-button'}
                                           disabled={!email || busy}
                          onClick={() => handleForgotPassword(auth, email, setEmailSent,
                                               setBusy, setError)}
                    >Send E-mail
                    </button>}
                    {emailSent && <button className={'bn-booknow-button'}
                                          disabled={busy}
                                          onClick={() => setForgetPassword(false)}
                    >Sign In
                    </button>}
                  </div>
                </div>
            }
          </div>
        </>
      </Dialog>
  )
})